export default {
  user: 'user', // 移动端和 wps 端
  device: 'device', // 设备端，包括：学生主机、教师主机、信息机、减压亭等
  platform: 'platform' // 云端后台，即音乐教学平台
}
